const r={current:null},n={current:!1};export{n as hasReducedMotionListener,r as prefersReducedMotion};
